import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BasicPageBody, BasicPageContainer } from '@medifind/containers';
import { IconMarker } from '@medifind/icons';
import { SEO } from '@medifind/seo';
import { MFLink } from '@medifind/shared-basic-components';
import { Button } from '@medifind/shared-basic-components';
import { logEventGA4 } from '@medifind/zustand';
import Footer from '../components/Footer';
import styles from './error.module.scss';
const isProd = process.env.NX_ENV === 'PROD';

const Error = ({ errorCode, title, message }) => {
  let displayMessage = message;
  if (isProd) {
    title = null;
    displayMessage = null;
  }

  useEffect(() => {
    if (errorCode) {
      const truncatedMessage = message.length <= 100 ? message : message.substring(0, 97).concat('...');
      logEventGA4('exception', { type: 'global', method: errorCode, description: truncatedMessage, fatal: true });
    }
  }, [errorCode]);

  return (
    <>
      <SEO
        noIndex={true}
        title={errorCode === 404 ? 'Page Not Found | MediFind' : 'Server Error | MediFind'}
        statusCode={errorCode || 500}
      />
      {/* The error class is important and is used by the prerenderer */}
      <BasicPageContainer classes={{ container: 'main' }}>
        <BasicPageBody>
          <Row className={styles['justify-content-center']}>
            <Col md={12} lg={12}>
              <div className={styles['error-content']}>
                <IconMarker />
                {errorCode === 404 ? (
                  <>
                    <h1 className={styles['error-content__title']}>404 Page Not Found</h1>
                    <p className={styles['small-cap']}>Sorry, we couldn’t find that URL.</p>
                  </>
                ) : errorCode === 429 ? (
                  <>
                    <h1 className={styles['error-content__title']}>429 Too Many Requests</h1>
                    <p className={styles['small-cap']}>
                      Too many requests were received from your address
                      <br /> wait a minute and try again.
                    </p>
                  </>
                ) : (
                  <>
                    <h1 className={styles['error-content__title']}>{title ? title : `${errorCode || 500} Internal Server Error`}</h1>
                    <p className={styles['small-cap']}>{displayMessage || 'Sorry, our server encountered an error.'}</p>
                  </>
                )}
                <p>Try searching for a condition or doctor above, or head to the home page to learn more about how MediFind works. </p>
                <MFLink to="/" noTabIndex aria-label="Home">
                  <Button color="blue" type="thin" label="Home Page" />
                </MFLink>
              </div>
            </Col>
          </Row>
        </BasicPageBody>
      </BasicPageContainer>
      <Footer />
    </>
  );
};

export default Error;
